import React from "react";
import Navigation from "../../components/Navigation";
// import Footer from "../../components/Footer";
import "./style.css";
import { Helmet } from 'react-helmet-async';

const About = () => {
	return (
		<>
			<Navigation />
			<main className="about">
				<Helmet>
					<title>Jean Tax & Legal Practitioners | About</title>
					<meta name="description" content="Jean Tax & Legal Practitioners - Learn more about our company and services" />
				</Helmet>
				<section className="about-hero">
					<h1>About Jean Tax & Legal</h1>
					<p>Dedicated to providing premium tax and legal services for individuals and businesses.</p>
				</section>

				<section className="about-content">
					<div className="about-text">
						{/* <h2>Vision Statement</h2>
						<p>To be a trusted and respected leader in tax, legal, compliance and estate administration services delivering strategic, ethical and client-centred solutions that protect and strengthen the financial and legal standing of individuals and businesses.</p> */}

						<p>Jean Tax and Legal Practitioners is a professional firm providing specialised services in taxation, accounting support, regulatory compliance, and financial advisory. </p>

						<p>The firm was established to assist businesses, organisations, and individuals in navigating complex financial and regulatory environments while maintaining full compliance with South African legislation.</p>

						<p>The firm combines expertise in taxation, accounting practices, and legal regulatory frameworks to deliver practical and reliable solutions to clients. Through this integrated approach, Jean Tax and Legal Practitioners assists businesses in managing financial risks,maintaining compliance, and strengthening financial governance.</p>

						{/* <h2>Core Values</h2>
						<p><b>Integrity</b>: We uphold the highest ethical standards in every matter, ensuring honesty, transparency and confidentiality at all times.</p>
						<p><b>Excellence</b>: We are committed to delivering accurate, strategic and high-quality services grounded in legal and tax expertise.</p>
						<p><b>Accountability</b>: We take responsibility for our work and act in the best interests of our clients with diligence and professionalism.</p>
						<p><b>Client-Centred Service</b>: We prioritise understanding each client’s unique needs and provide tailored, practical solutions.</p>
						<p><b>Compliance & Precision</b>: We value strict adherence to legal and regulatory frameworks while maintaining meticulous attention to detail.</p>
						<p><b>Compassion</b>: Especially in matters such as deceased estates, we approach our work with sensitivity, respect and care.</p> */}
					</div>
					{/* <div className="about-image"></div> */}
				</section>
			</main>
			{/* <Footer /> */}
		</>
	);
};

export default About;
